import {Modal, Row, Col,Button, Card, Form} from 'react-bootstrap'
import { Image, Schedule, Media, MediaGroup, MediaText, Block,Icon } from '..';
import DataTable from  '../DataTable/DataTable';
import { useEffect , useState} from 'react';
import { useApiClient } from '../../ApiService/useApiClient';

const baseURL2 = "HMCareStaff/stafflist/";    

export const tableColumns = [
    {
      name: "id",
      selector: (row) => row.customerid,
      sortable: false,
      hide : "lg",
      omit : true,

    },
    {
        name: "name",
        selector: (row) => row.name,
        sortable: true,                
    },
        
  ];

  

const AvailableCarersListSelect = ({ClientsModal,closeClientsModal,clientSelect, title}) => {
      
  const api = useApiClient()

    const[data, setData] = useState(null);      
    const[error, setError] = useState(null); 

    const ApiGetData = async (URL,setdataFunc, setErrorFunc) => {
         
      await api.get(URL)
      .then((Response)=>{
        setdataFunc(Response.data);
      })
      .catch((err=>{
        setErrorFunc(err);
      }));}


 useEffect(()=>{    
  ApiGetData(baseURL2,setData, setError);
 },[])


  return (
    <Modal show={ClientsModal} onHide={closeClientsModal} size="md">
            <Modal.Header closeButton>
              <Modal.Title className="event-title" as="h4">{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
           
               <Block>
     
                    <DataTable 
                        tableClassName="data-table-head-light table-responsive" 
                        pointerOnHover={true} 
                        data={data}
                        columns={tableColumns} 
                        striped={true} 
                        highlightOnHover={true}  
                        filterFieldName="name" 
                        onRowClicked={(row,event)=>{ clientSelect(row) }} 
                    />   

              </Block>
            </Modal.Body>
            <Modal.Footer>              
            </Modal.Footer>
        </Modal>
  )
}

export default AvailableCarersListSelect